import Modal from 'react-modal'
import React from 'react'
import { Button } from 'loyal-react'
import PropTypes from 'prop-types'

const CreditApprovalModal = ({
  modal,
  creditId,
  type,
  value,
  toggleModal,
  submit
}) => {
  return (
    <Modal
      isOpen={modal}
      onRequestClose={toggleModal}
      style={{
        content: {
          top: '40%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          width: '600px'
        }
      }}
    >
      <div className='row'>
        <div className='col-12'>
          <h2 className='txt-initial color-brand-1 mr-auto'>
            {type === 1 ? 'Aprovar' : 'Recusar'} Crédito
          </h2>
        </div>
      </div>
      <hr />
      <div className='row mt-2'>
        <div className='col-12 txt-font-body txt-subtitle'>
          <h5>
            Deseja realmente <strong>{type === 1 ? 'aprovar' : 'recusar'}</strong> o crédito <strong>#{creditId}</strong> com um total de <strong>{value}</strong> pontos?
          </h5>
        </div>
      </div>
      <div className='row mt-2'>
        <div className='col-6'>
          <Button
            id='closeModalDelete'
            name='closeModalDelete'
            className='btn btn-sm mx-0'
            text='Cancelar'
            onClick={toggleModal}
          />
        </div>
        <div className='col-6'>
          { /* eslint-disable no-return-await */ }
          <Button
            id='saveDelete'
            name='saveDelete'
            className='btn btn-sm txt-uppercase txt-center btn-featured'
            text='Confirmar'
            onClick={async () => await submit(creditId)}
          />
          { /* eslint-enable no-return-await */ }
        </div>
      </div>
    </Modal>
  )
}

CreditApprovalModal.propTypes = {
  modal: PropTypes.bool,
  creditId: PropTypes.number,
  type: PropTypes.number,
  value: PropTypes.string,
  toggleModal: PropTypes.func,
  submit: PropTypes.func
}

export default CreditApprovalModal



// WEBPACK FOOTER //
// ./src/features/FocalPoint/CreditApproval/CreditApprovalModal.js